/**
 * Detect whether the app is running inside the Discord Activity iframe.
 *
 * Discord serves Activities under https://<app_id>.discordsays.com/.proxy/...
 * — every request comes through that origin pattern. Two signals
 * independently confirm it:
 *
 *   1. window.location.hostname matches /\.discordsays\.com$/.
 *   2. The URL path starts with /.proxy/.
 *
 * Either is sufficient (we use OR, not AND, to be forgiving of
 * deep-linked entry points the SDK might construct internally).
 *
 * Returns false in any non-browser environment (SSR safety),
 * though HSH is currently CSR-only.
 */
export function isLikelyEmbedded() {
    if (typeof window === 'undefined' || !window.location) {
        return false;
    }
    const host = window.location.hostname || '';
    const path = window.location.pathname || '';
    return host.endsWith('.discordsays.com') || path.startsWith('/.proxy/');
}
